import React, { useCallback } from 'react'

import { useWindowSize } from 'shared/hooks'
import { detectDevice } from 'shared/utils/detectDevice'

interface Props extends React.VideoHTMLAttributes<HTMLVideoElement> {
  videoRef?: React.LegacyRef<HTMLVideoElement>
  type?: string
  childTablet?: (...args: any) => JSX.Element
}

export const Video = ({
  videoRef,
  src,
  type = 'video/mp4',
  childTablet = () => <></>,
  ...rest
}: Props): JSX.Element => {
  const { isMobile } = useWindowSize()
  const isTablet = detectDevice()

  const render = useCallback(() => {
    if (isMobile || isTablet) {
      return childTablet()
    }

    return (
      <video
        autoPlay={false}
        controls={false}
        muted={true}
        ref={videoRef}
        {...rest}
      >
        <source src={src} type={type}></source>
        Sorry, your browser doesnt support embedded videos.
      </video>
    )
  }, [childTablet, isMobile, isTablet, rest, src, type, videoRef])

  return render()
}
